export default __webpack_public_path__ + "static/media/SkeletonImage.83e8ba62.svg";